module.exports = __webpack_public_path__ + "img/1.53cd2284.jpg";